import React, { Component, PropTypes } from 'react';
import {findDOMNode} from 'react-dom';
import { Button, message } from 'antd';
message.config({
  top: 100,
  duration: 2,
});

export default class ButtonGroup extends Component {
    static propTypes = {
        // handleSubjectChange: PropTypes.func,
        text: PropTypes.string,
        copyValue: PropTypes.string,
    }

    componentDidMount() {
        setTimeout(()=>{this.copy()},0)
    }

    copy = () => {
        let _this = this
        var copyBtn = new window.ClipboardJS('.copyBtn',{
                // 通过target指定要复印的节点
            text: function() {
                    return _this.props.copyValue
                }
            });
        copyBtn.on("success",function(e){
            // 复制成功
            message.success('复制成功')
            e.clearSelection();
        });
        copyBtn.on("error",function(e){
            //复制失败；
            console.log( e )
        });
    }



    render() {
    const { text } = this.props;
        return (
                <Button className="copyBtn" >{ text }</Button>
        )
    }
}



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/CopyText.js